module.exports = __webpack_public_path__ + "static/media/locationRed.87c0ad9c.svg";